import { store } from '../store';
import { companyIdSelector } from '../store/selectors/auth';

export const getCompanyId = () => {
  return companyIdSelector(store.getState());
};
